module.exports = __webpack_public_path__ + "img/flashy_logo_HD.2b5a9860.svg";